import { http } from '@/http/axios.js'
export function updatePwdAPI(data) {
  return http({
    url: '/api/manage/staff/passport/editPassport',
    method: 'post',
    data
  })
}
